import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom, palette }: Theme) => ({
  root: {
    padding: 12,
    fontSize: 14,
    color: custom.grey[3],
    lineHeight: 1.5,
    '& a': {
      color: palette.primary.main,
      textDecoration: 'none',
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
  icon: {
    padding: 0,
    marginRight: 15,
    fontSize: 24,
    display: 'flex',
    alignItems: 'center',
  },
  error: {
    backgroundColor: custom.status.danger.main,
    '& $icon': {
      color: custom.status.danger.contrastText,
    },
  },
  info: {
    backgroundColor: custom.grey[0],
    '& $icon': {
      display: 'none',
    },
  },
  success: {
    backgroundColor: custom.status.success.light,
    '& $icon': {
      color: custom.status.success.dark,
    },
  },
  warning: {
    backgroundColor: custom.status.warning.main,
    '& $icon': {
      color: custom.status.warning.contrastText,
    },
  },
  advisory: {
    backgroundColor: custom.blue[4],
    '& $icon': {
      color: custom.blue[0],
    },
  },
  title: {
    fontWeight: 'bold',
    marginTop: 3,
  },
  message: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: 0,
    width: '100%',
    whiteSpace: 'pre-wrap',
  },
}));
